/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_OriginInputs */

const en_edit_origin = /** @type {(inputs: Edit_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Origin`)
};

const es_edit_origin = /** @type {(inputs: Edit_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar origen`)
};

/**
* | output |
* | --- |
* | "Edit Origin" |
*
* @param {Edit_OriginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const edit_origin = /** @type {((inputs?: Edit_OriginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_OriginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_origin(inputs)
	return es_edit_origin(inputs)
});